import React, { PureComponent } from 'react'
import { string, shape, bool, func } from 'prop-types'
import ReactMarkdown from 'react-markdown'
import { Paragraph, Strong, ListItem, List, Link } from '@ycos/primitives'
import { createComponent } from '@ycos/fela'
import Heading from './Heading'

const ALLOWED_ELEMENTS = ['p', 'em', 'strong', 'a', 'ol', 'ul', 'li', 'h1', 'h2', 'h3']

// the last child of the markdown component shouldn't have any margin bottom (eg. group of paragraphs)
// its possible to override this rule with removeLastChildMargin prop
const RootNode = createComponent(
  'RootNode',
  ({ removeLastChildMargin }) => ({
    '> *:last-child': {
      marginBottom: removeLastChildMargin ? 0 : null
    }
  }),
  'div'
)

class Markdown extends PureComponent {
  renderParagraph = ({ children }) => (
    <Paragraph
      textAlign={this.props.textAlign}
      dropCaps={this.props.dropCaps}
      inverseColor={this.props.inverseColor}
      onMarkdownTargetClick={this.props.onMarkdownTargetClick}
      smallMargin={this.props.smallMargin}
    >
      {children}
    </Paragraph>
  )

  renderStrong = ({ children }) => <Strong inverseColor={this.props.inverseColor}>{children}</Strong>
  renderLink = ({ children, href }) => (
    <Link inverseColor={this.props.inverseColor} href={href} onClick={() => this.props.onMarkdownTargetClick && this.props.onMarkdownTargetClick(href)}>
      {children}
    </Link>
  )

  render() {
    const { anchorpoint, teaserText, components, onMarkdownTargetClick, removeLastChildMargin } = this.props

    return (
      <div id={anchorpoint}>
        <RootNode removeLastChildMargin={removeLastChildMargin}>
          <ReactMarkdown
            components={{
              p: this.renderParagraph,
              h1: Heading,
              h2: Heading,
              h3: Heading,
              strong: this.renderStrong,
              li: ListItem,
              ol: List,
              ul: List,
              a: this.renderLink,
              ...components
            }}
            allowedElements={ALLOWED_ELEMENTS}
            children={teaserText}
            onMarkdownTargetClick={onMarkdownTargetClick}
          />
        </RootNode>
      </div>
    )
  }
}

Markdown.propTypes = {
  anchorpoint: string,
  textAlign: string,
  teaserText: string.isRequired,
  components: shape(),
  inverseColor: bool,
  dropCaps: bool,
  onMarkdownTargetClick: func,
  removeLastChildMargin: bool
}

Markdown.defaultProps = {
  anchorpoint: null,
  components: {},
  textAlign: undefined,
  inverseColor: false,
  dropCaps: false,
  removeLastChildMargin: true
}

export default Markdown
